import React from 'react';
import { Headings, PrimaryCircleProgressBar, CircleProgress } from '@sentara-health/optimahealth_web';
import { useTranslation } from 'react-i18next';

interface BenefitItem {
  name: string;
  amount: string;
  limit: string;
}

interface AnnualBenefitSummaryProps {
  benefitData: {
    deductible: BenefitItem;
    moop: BenefitItem;
  };
}

const AnnualBenefitSummary: React.FC<AnnualBenefitSummaryProps> = ({
  benefitData,
}) => {
  const { t } = useTranslation();
  if (!benefitData) return null;

  const { deductible, moop } = benefitData;

  return (
    <div className="text-center my-5">
          <div className="text-start mb-5">      
        <Headings
          level={3}
          text={t('medicalClaims.annualBenefitSummary')}
          variant="semiBold"
          className="mb-2"
        />
      </div>

      <div className="d-flex flex-wrap justify-content-center gap-5 mt-8">
        <div className="text-center">
          <PrimaryCircleProgressBar
            className="circle-progress-member"
            header={t('medicalClaims.deductible')}
            percentage={deductible.amount}
            total={deductible.limit}
            dataTestId="deductible_member"
            title={t('medicalClaims.deductible')}
          />
        </div>

        <div className="text-center">
          <CircleProgress
            className="circle-progress-family"
            header={t('medicalClaims.maxOutOfPocket')}
            percentage={moop.amount}
            total={moop.limit}
            dataTestId="moop_member"
            title={t('medicalClaims.maxOutOfPocket')}
            isPrimary={false}
          />
        </div>
      </div>
    </div>
  );
};

export default AnnualBenefitSummary;